import Store1Image from './stores/store-publix.jpg'
import Store4Image from './stores/store-harris-teeter.jpg'

import Store7Image from './stores/store-fred-meyer.jpg'
import Store8Image from './stores/store-qfc.jpg'
import Store12Image from './stores/store-food-4-less.jpg'

import Store13Image from './stores/store-sprouts.jpg'
import Store15Image from './stores/store-giant.jpg'
import Store16Image from './stores/store-giant-landover.jpg'
import Store17Image from './stores/store-stop-and-shop.jpg'

import Store19Image from './stores/store-albertsons.jpg'
import Store20Image from './stores/store-safeway.jpg'
import Store21Image from './stores/store-vons.jpg'
import Store22Image from './stores/store-shaws.jpg'

import Store25Image from './stores/store-harmons.jpg'
import Store26Image from './stores/store-gelsons.jpg'
import Store27Image from './stores/store-heinens.jpg'
import Store28Image from './stores/store-fairway.jpg'
import Store29Image from './stores/store-weis.jpg'
import Store30Image from './stores/store-national-coop-grocers.jpg'

import Store31Image from './stores/store-infra.jpg'
import Store32Image from './stores/store-schucks.jpg'
import Store33Image from './stores/store-earth-origins.jpg'
import Store34Image from './stores/store-nugget-markets.jpg'
import Store35Image from './stores/store-lowes-foods.jpg'
import Store39Image from './stores/store-kings.jpg'

import StoreRayles from './stores/raleys.png'
import StoreKowalskis from './stores/kowalskis-logo.jpeg'
import StoreLassens from './stores/lassens.png'
import StoreDier from './stores/dierbergs.png'
import StoreHarp from './stores/harps.png'
import StoreAkins from './stores/akins.jpg'
import StoreChamberlin from './stores/chamberlins.jpg'
import StoreNatural from './stores/its-only-natural.jpg'
import StoreUnited from './stores/united-supermarkets.jpg'
import StoreWalmart from './stores/walmart.jpg'
import StoreBigY from './stores/BigY-Logo.png'

let InlineListData = [
  {
    image: Store1Image,
    imageAlt: 'Publix',
    link: 'http://store.publix.com/publix/'
  },

  {
    image: Store4Image,
    imageAlt: 'Harris Teeter',
    link: 'https://www.harristeeter.com/store/#/app/store-locator'
  },
  {
    image: Store7Image,
    imageAlt: 'Fred Meyer',
    link: 'https://www.fredmeyer.com/stores/search'
  },
  {
    image: Store8Image,
    imageAlt: 'QFC',
    link: 'https://www.qfc.com/stores/search'
  },
  {
    image: Store12Image,
    imageAlt: 'Food 4 Less',
    link: 'https://www.food4less.com/stores/search'
  },
  {
    image: Store13Image,
    imageAlt: "Sprout's",
    link: 'https://www.sprouts.com/stores/'
  },
  {
    image: Store15Image,
    imageAlt: 'Giant Carlisle',
    link: 'https://giantfoodstores.com/store-locator/'
  },
  {
    image: Store16Image,
    imageAlt: 'Giant Landover',
    link: 'https://giantfood.com/store-locator/'
  },
  {
    image: Store17Image,
    imageAlt: 'Stop & Shop',
    link: 'https://stopandshop.com/store-locator/'
  },
  {
    image: Store19Image,
    imageAlt: "Alberton's",
    link: 'http://www1.albertsons.com/shopstores/tools/store-locator.page'
  },
  {
    image: Store20Image,
    imageAlt: 'Safeway',
    link: 'http://www.safeway.com/shopstores/tools/store-locator.page'
  },
  {
    image: Store21Image,
    imageAlt: "Von's",
    link: 'http://www.vons.com/ShopStores/tools/store-locator.page'
  },
  {
    image: Store22Image,
    imageAlt: "Shaw's",
    link: 'http://www1.shaws.com/ShopStores/tools/store-locator.page'
  },
  {
    image: Store26Image,
    imageAlt: "Gelson's",
    link: 'https://gelsons.com/store-locations'
  },
  {
    image: Store27Image,
    imageAlt: "Heinen's",
    link: 'http://www.heinens.com/home/contact-us/all-locations/'
  },
  {
    image: Store28Image,
    imageAlt: 'Fairway',
    link: 'https://www.fairwaymarket.com/store-locator/'
  },
  {
    image: Store29Image,
    imageAlt: 'Weis',
    link: 'https://www.weismarkets.com/stores#/?coordinates=33.975380731912374,-79.34615000000002&zoom=5'
  },
  {
    image: Store30Image,
    imageAlt: 'NCGA',
    link: 'https://www.ncg.coop/find-co-op'
  },
  {
    image: Store31Image,
    imageAlt: 'INFRA',
    link: 'http://www.naturalfoodretailers.net/member-directory'
  },
  {
    image: Store32Image,
    imageAlt: "Schnuck's",
    link: 'https://locations.schnucks.com/'
  },
  {
    image: Store33Image,
    imageAlt: 'Earth Origins',
    link: 'https://earthoriginsmarket.com/locations'
  },
  {
    image: Store34Image,
    imageAlt: 'Nugget',
    link: 'https://www.nuggetmarket.com/locations/'
  },
  {
    image: Store39Image,
    imageAlt: 'Kings',
    link: 'https://kingsfoodmarkets.com/store-locator'
  },
  {
    image: StoreBigY,
    imageAlt: 'BigY',
    link: 'https://www.bigy.com/rs/storelocator'
  },
  {
    image: StoreRayles,
    imageAlt: "Raley's",
    link: 'https://www.raleys.com/store-locator/'
  },
  {
    image: StoreDier,
    imageAlt: "Dierberg's",
    link: 'http://www.dierbergs.com/MyDierbergs/Locations'
  },
  {
    image: StoreKowalskis,
    imageAlt: "Kowalski's",
    link: 'https://www.kowalskis.com/find-store'
  },
  {
    image: StoreLassens,
    imageAlt: "Lassen's",
    link: 'https://www.lassens.com/locations/'
  },
  {
    image: Store25Image,
    imageAlt: 'Harmons',
    link: 'https://www.harmonsgrocery.com/'
  },
  {
    image: Store35Image,
    imageAlt: 'Lowes Foods',
    link: 'http://www.lowesfoods.com/aboutus/stores/'
  },
  {
    image: StoreHarp,
    imageAlt: "Harp's Foods",
    link: 'https://www.harpsfood.com/StoreLocator/'
  },
  {
    image: StoreAkins,
    imageAlt: 'Akins',
    link: 'http://akins.com/locations/'
  },
  {
    image: StoreChamberlin,
    imageAlt: 'Chamberlin',
    link: 'https://chamberlins.com/locations/'
  },
  {
    image: StoreNatural,
    imageAlt: "It's Only Natural",
    link:
      'http://www.itsonlynaturalmarket.com/retailer/store_templates/shell_id_1.asp?storeID=559B4D5864C14F0DBE0543F5BAD7FD4A'
  },
  {
    image: StoreUnited,
    imageAlt: 'United Supermarkets',
    link: 'https://www.unitedsupermarkets.com/'
  },
  {
    image: StoreWalmart,
    imageAlt: 'Walmart',
    link: 'https://www.walmart.com/'
  }
]

export default InlineListData



// WEBPACK FOOTER //
// ./src/views/whereToBuy/InlineListData.js